import { useEffect, useState } from "react";
const useIsOnline = () => {
  const [isOnline, setIsOnline] = useState<boolean>(true);
  const [isConnectionLost, setIsConnectionLost] = useState<boolean>(false);
  const handleOnline = () => {
    setIsOnline(true);
  };
  const handleOffline = () => {
    setIsOnline(false);
    setIsConnectionLost(true);
  };
  useEffect(() => {
    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);
    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  });
  return { isOnline, isConnectionLost };
};
export default useIsOnline;
